function getParseItem(key) {
  try {
    const data = localStorage.getItem(`config_${key}`)
    return JSON.parse(data)
  } catch (e) {
    return null
  }
}

function setParseItem(key, value) {
  if (key && value) {
    localStorage.setItem(`config_${key}`, JSON.stringify(value))
  }
}

const cacheUtil = {
  getParseItem,
  setParseItem
}

export default cacheUtil


// WEBPACK FOOTER //
// ./src/sdk/cache.js